export const PRODUCTTYPES = [
  'Sublet Repair',
  'Labour',
  'Stock',
  'Tyres',
  'Consumable',
  'Accessories'
];